module.exports = __webpack_public_path__ + "img/bluesky3100_35.53164ec9.jpg";